// Avec Package privé github
// Test ESM (dans un environnement moderne)
import MarsselBundle from "@marssel-vb/marssel";
// import MarsselBundle from "marssel-npm";
import { userThemes } from "./theme.config.js";
import { componentStyles } from "./marssel.config.js";
const { Marssel } = MarsselBundle;
// const {
//     Marssel,
//     FontManager,
//     ThemeManager,
//     StyleManager,
//     properties,
//     breakpoints
// } = MarsselBundle;
const app = new Marssel({
    lazyload: true,
    themes: userThemes,
    components: componentStyles,
    // components: {
    //     h1: "bg-[blue]",
    // },
    // paths: {
    //     fontsManifest: '/assets/manifests/fonts.json',
    //     iconsManifest: '/assets/manifests/icons.json'
    // }
});

// Utilisation des managers individuels
// const fontManager = new FontManager();
// const themeManager = new ThemeManager();
// const toastManager = new ToastManager();
window.marssel = app;

// C'est cette ligne qui résoudra l'erreur de l'iframe
window.Marssel = Marssel;

// window.marssellManagers = {
//     font: fontManager,
//     theme: themeManager,
//     toast: toastManager,
// };

// Attendre que le DOM soit chargé
document.addEventListener("DOMContentLoaded", function () {
    const copyButtons = document.querySelectorAll(".copy-button");

    copyButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const codeBlock = this.parentElement.querySelector("code");
            const text = codeBlock ? codeBlock.textContent : "";
            if (!text) return;

            // Méthode 1 : Clipboard API (moderne)
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                    .writeText(text)
                    .then(() => {
                        showCopySuccess(this);
                    })
                    .catch((err) => {
                        console.error("Erreur clipboard:", err);
                        fallbackCopy(text, this);
                    });
            } else {
                // Méthode 2 : Fallback pour HTTP ou vieux navigateurs
                fallbackCopy(text, this);
            }
        });
    });

    function fallbackCopy(text, button) {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand("copy");
            showCopySuccess(button);
        } catch (err) {
            console.error("Erreur lors de la copie:", err);
            alert("Impossible de copier le code");
        }

        document.body.removeChild(textarea);
    }

    function showCopySuccess(button) {
        button.classList.add("copied");
        button.querySelector(".copy-icon").textContent = "✓";

        setTimeout(() => {
            button.classList.remove("copied");
            button.querySelector(".copy-icon").textContent = "📋";
        }, 2000);
    }
});
